import { render } from "./toggle-button.vue?vue&type=template&id=1643e202&scoped=true"
import script from "./toggle-button.vue?vue&type=script&lang=js"
export * from "./toggle-button.vue?vue&type=script&lang=js"

import "./toggle-button.vue?vue&type=style&index=0&id=1643e202&lang=scss&scoped=true"
import "./toggle-button.vue?vue&type=style&index=1&id=1643e202&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1643e202"]])

export default __exports__